import ContactsController from './contacts.controller';
import ContactAddController from './contactAdd.controller';
import ContactDetailController from './contactDetail.controller';

export default angular
    .module('advinda.contacts.controllers', [])
    .controller('ContactsController', ContactsController)
    .controller('ContactAddController', ContactAddController)
    .controller('ContactDetailController', ContactDetailController);



/** WEBPACK FOOTER **
 ** ./src/app/components/contacts/contacts.controllers.js
 **/